export default "__VITE_ASSET__0wOapFcY__"